var _path, _ellipse, _ellipse2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConfusedFace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.934 18.129a10.182 10.182 0 00-7.562-1.874 10.2 10.2 0 00-6.678 4.012",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.454,
    cy: 7.136,
    rx: 2.454,
    ry: 3.136
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.546,
    cy: 7.136,
    rx: 2.454,
    ry: 3.136
  })));
}

export default SvgConfusedFace;